module.exports = __webpack_public_path__ + "font1_amaranth.png?15ec21264fb9dc2e7e2ca6d1124bbb13";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/josif_pancic/font1_amaranth.png
// module id = 72
// module chunks = 0